EPST.contactUs = {
  _autoload: [
    //Functions binding should be present here which need to be called on load
    'bindMyAccountLink'
  ],

  bindMyAccountLink: function() {
    $(document).on('click', '.link-my-account', function(e) {
      e.preventDefault();

      if ($('.header-signin').length > 0) {
        // not logged in
        $('.header-signin .btn-link').click();
      } else {
        window.location.href = '/my-account-home/page';
      }
    });
  }
};
